export default {
  SET_ROOM_INFO(state, roomInfo) {
    state.roomInfo = roomInfo
  },
  SET_IS_HOST(state, isHost) {
    state.isHost = isHost
  },
  SET_IS_MUTED(state, isMuted) {
    state.isMuted = isMuted
  },
  ADD_SPEAKER_REQUEST(state, request) {
    if (!state.pendingSpeakerRequests.some(r => r.userId === request.userId)) {
      state.pendingSpeakerRequests.push(request)
    }
  },
  REMOVE_SPEAKER_REQUEST(state, userId) {
    state.pendingSpeakerRequests = state.pendingSpeakerRequests.filter(r => r.userId !== userId)
  },
  CLEAR_PENDING_REQUESTS(state) {
    state.pendingSpeakerRequests = []
  },

  // Speaker Mutations
  SET_SPEAKERS(state, speakers) {
    state.speakers = speakers
  },
  ADD_SPEAKER(state, speaker) {
    if (!state.speakers.some(s => s.id === speaker.id)) {
      state.speakers.push({ ...speaker, isSpeaking: false, isMuted: speaker.isMuted || false })
    }
  },
  REMOVE_SPEAKER(state, speakerId) {
    state.speakers = state.speakers.filter(s => s.id !== speakerId)
  },
  UPDATE_SPEAKER(state, updatedSpeaker) {
    // Check if the user being updated is the main host
    if (state.mainHost && state.mainHost.id === updatedSpeaker.id) {
      console.warn(`[Mutation UPDATE_SPEAKER] Attempting to update mainHost (ID: ${updatedSpeaker.id}) via UPDATE_SPEAKER. This mutation only updates the speakers array. Use a different mutation/action for mainHost.`);
      // Optionally, update mainHost here if desired, but separating concerns is better
      // state.mainHost = { ...state.mainHost, ...updatedSpeaker };
      // return; // Stop further processing if mainHost update is handled elsewhere
    }

    const index = state.speakers.findIndex(s => s.id === updatedSpeaker.id)
    if (index !== -1) {
      const existingSpeaker = state.speakers[index]
      const newSpeakerData = {
        ...existingSpeaker,
        ...updatedSpeaker,
      }

      // Replace splice with creating a new array for guaranteed reactivity
      state.speakers = state.speakers.map((speaker, i) => {
        return i === index ? newSpeakerData : speaker
      })
    } else {
      console.warn(`[Mutation UPDATE_SPEAKER] Speaker not found with ID: ${updatedSpeaker.id}`)
    }
  },

  // Audience Mutations
  SET_AUDIENCE(state, audience) {
    state.audience = audience
  },
  ADD_AUDIENCE_MEMBER(state, member) {
    if (!state.audience.some(a => a.id === member.id)) {
      state.audience.push(member)
    }
  },
  REMOVE_AUDIENCE_MEMBER(state, memberId) {
    state.audience = state.audience.filter(a => a.id !== memberId)
  },

  // Main Host Mutation
  SET_MAIN_HOST(state, hostData) {
    state.mainHost = hostData ? { ...hostData, isSpeaking: false, isMuted: hostData.isMuted || false } : null
  },

  // Room Details Mutations
  SET_STREAM_TITLE(state, title) {
    state.streamTitle = title
  },
  SET_GOALS(state, goals) {
    state.goals = goals
  },

  // --- Updated Mutation ---
  UPDATE_GOAL_PROGRESS(state, { goalIndex, newCurrentValue, newAchievedStatus }) {
    if (goalIndex >= 0 && goalIndex < state.goals.length) {
      const goal = state.goals[goalIndex]
      // Directly use the values passed from the action (which got them from the event)
      const updatedGoal = {
        ...goal,
        currentValue: newCurrentValue,
        achieved: newAchievedStatus,
      }

      // Update the array immutably for reactivity
      state.goals = state.goals.map((g, index) => {
        return index === goalIndex ? updatedGoal : g
      })
    } else {
      console.warn(`[Mutation UPDATE_GOAL_PROGRESS] Invalid goalIndex received: ${goalIndex}`)
    }
  },
  // --- End Updated Mutation ---

  // Audience Count Mutation
  SET_AUDIENCE_COUNT(state, count) {
    state.audienceCount = count
  },

  // Gift Senders Mutation
  SET_GIFT_SENDERS(state, senders) {
    state.giftSenders = senders || []
  },

  // Mutation to set available gifts
  SET_AVAILABLE_GIFTS(state, gifts) {
    state.availableGifts = Array.isArray(gifts) ? gifts : []
  },

  // Sets the speaking status for a specific user (speaker or mainHost)
  SET_USER_SPEAKING(state, { userId, isSpeaking }) {
    if (state.mainHost && state.mainHost.id === userId) {
      state.mainHost = { ...state.mainHost, isSpeaking }
    } else {
      const speakerIndex = state.speakers.findIndex(s => s.id === userId)
      if (speakerIndex !== -1) {
        state.speakers.splice(speakerIndex, 1, {
          ...state.speakers[speakerIndex],
          isSpeaking,
        })
      }
    }
  },
}
